import { isComrade } from '@/brands';

// GTM container + first-party proxy host per brand. Keep IDs in sync with the
// noscript snippet in vite.config.ts.
const GTM_CONFIG = {
  glf: { id: 'GTM-P9968DNF', proxy: 'https://t.growlaw.co/sdk.js' },
  cwa: { id: 'GTM-5ZKVDKMC', proxy: 'https://t.comradeweb.com/sdk.js' },
} as const;

// Loads gtm.js through the first-party worker proxy so ad blockers that
// filter googletagmanager.com don't kill tracking. If the worker is down or
// over the free-plan daily limit, falls back to loading gtm.js straight from
// Google — worst case equals the old setup.
export default function GoogleTagManager() {
  if (import.meta.env.VITE_API_ENV == 'prod') {
    const { id, proxy } = isComrade() ? GTM_CONFIG.cwa : GTM_CONFIG.glf;

    const dataLayer = ((window as any).dataLayer =
      (window as any).dataLayer || []);
    dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const query = '?id=' + id;
    const script = document.createElement('script');
    script.async = true;
    script.src = proxy + query;
    script.onerror = () => {
      const fallback = document.createElement('script');
      fallback.async = true;
      fallback.src = 'https://www.googletagmanager.com/gtm.js' + query;
      document.head.appendChild(fallback);
    };
    document.head.appendChild(script);
  }
}
